module.exports = __webpack_public_path__ + "static/media/shackleton.b58fb992.jpg";